import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import SignupForm from "../components/SignupForm";
import bgPattern from "../assets/Log In.jpg";
import illustration from "../assets/illustration.png";

const AuthPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  // Determine mode from URL path
  useEffect(() => {
    if (location.pathname === '/signup') {
      setMode('signup');
    } else {
      setMode('login');
    }
  }, [location.pathname]);

  const handleModeChange = (newMode: 'login' | 'signup') => {
    setMode(newMode);
    navigate(newMode === 'login' ? '/login' : '/signup');
  };

  const [bgReady, setBgReady] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.src = bgPattern;
    img.onload = () => setBgReady(true);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: bgReady ? `url(${bgPattern})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex flex-col items-start" style={{ width: 1300, maxWidth: '100%' }}>
        <div className="flex rounded-3xl overflow-hidden w-full gap-[68px]">
          {/* Left: Form Box, fixed 568x710px, 79px top/bottom, 40px left/right padding, 24px radius */}
          <div className="flex flex-col justify-center items-center mt-[50px] mb-[50px]">
            <div className="w-[500px] pt-[79px] pb-[79px] px-[40px] flex flex-col items-center bg-white rounded-[24px]">
              <h2 className="mt-[32px] text-3xl font-semibold text-[#4A3B8E] mb-2 text-center">
                {mode === 'login' ? 'Welcome back!' : 'Create your account'}
              </h2>
              <p className="text-gray-500 mb-8 text-center font-normal">
                {mode === 'login' 
                  ? 'Please enter your details to sign in' 
                  : 'Please enter your details to create your account'
                }
              </p>
              {mode === 'login' ? <LoginForm /> : <SignupForm />}
            </div>
            {mode === 'login' ? (
              <div className="w-[568px] mx-0 ml-[0px] mt-4 flex flex-row items-center justify-center text-center">
                <span className="text-white text-sm">Don't have an account?&nbsp;</span>
                <button 
                  type="button" 
                  onClick={() => handleModeChange('signup')} 
                  className="text-black text-sm font-semibold hover:underline bg-transparent border-none p-0 m-0 cursor-pointer"
                >
                  Sign up now.
                </button>
              </div>
            ) : (
              <div className="w-[568px] mx-0 ml-[0px] mt-4 flex flex-row items-center justify-center text-center">
                <span className="text-white text-sm">Already have an account?&nbsp;</span>
                <button 
                  type="button" 
                  onClick={() => handleModeChange('login')} 
                  className="text-black text-sm font-semibold hover:underline bg-transparent border-none p-0 m-0 cursor-pointer"
                >
                  Log in
                </button>
              </div>
            )}
          </div>
          {/* Right: Heading and Illustration, fully transparent */}
          <div className="hidden md:flex flex-1 flex-col items-center justify-center">
            <h2 className="pt-[64px] text-[42px] font-semibold text-[#4A3B8E] text-center whitespace-pre-line">
              {mode === 'login' ? (
                <>
                  Welcome back!
                  <br />
                  Please sign in to your
                  <br />
                  WorkinX AI account
                </>
              ) : (
                <>
                  Join WorkinX AI!
                  <br />
                  Create your account to
                  <br />
                  start optimizing your listings
                </>
              )}
            </h2>
            <img src={illustration} alt="Illustration" loading="lazy" style={{ width: 766, height: 552 }} className="max-w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage; 